import { z } from "zod";
import { ISSUE_STATUSES, ISSUE_PRIORITIES } from "../constants.js";
export const createIssueSchema = z.object({
    companyId: z.string().uuid(),
    title: z.string().min(1).max(500),
    description: z.string().max(10000).optional(),
    status: z.enum(ISSUE_STATUSES).optional(),
    priority: z.enum(ISSUE_PRIORITIES).optional(),
    projectId: z.string().uuid().nullable().optional(),
    goalId: z.string().uuid().nullable().optional(),
    parentId: z.string().uuid().nullable().optional(),
    assigneeAgentId: z.string().uuid().nullable().optional(),
    assigneeUserId: z.string().nullable().optional(),
    createdByAgentId: z.string().uuid().nullable().optional(),
});
export const updateIssueSchema = z.object({
    title: z.string().min(1).max(500).optional(),
    description: z.string().max(10000).nullable().optional(),
    status: z.enum(ISSUE_STATUSES).optional(),
    priority: z.enum(ISSUE_PRIORITIES).optional(),
    projectId: z.string().uuid().nullable().optional(),
    goalId: z.string().uuid().nullable().optional(),
    assigneeAgentId: z.string().uuid().nullable().optional(),
    assigneeUserId: z.string().nullable().optional(),
});
//# sourceMappingURL=issue.js.map